<template>
  <b-container id="app">
    <nav class="navbar fixed-top">
      <div id="nav" class="container">
        <div class="float-left">
          <img alt="Diabetes Coalition" src="./assets/Diabetes-Coalition-PB-White-1.png">
        </div>
        <div class="container top-menu-nav" v-if="isLogged">
          <div>
            <div class="float-right">
              <button class="btn btn-danger" v-on:click.prevent="handleLogOut">Log out</button>
            </div>
            <div class="float-right">
              <router-link to="/">Home</router-link>|
              <div v-if="isAdministrator">
                <router-link :to="{ name: 'surveyAdd', params: { isNew: 1 }}">Survey Mode</router-link>
              </div>
              <div v-if="isAdministrator">
                <router-link :to="{ name: 'surveyAdd', params: { isNew: 0 }}">Manage Survey</router-link>
              </div>
              <div v-if="isAdministrator">
                <router-link to="/locations">Locations</router-link>
              </div>
              
            </div>
          </div>
          <br />
          <div style="color: white; font-weight: 700; padding-top: 10px;">Based Upon American Diabetes Association (ADA) Risk Assessment</div>
        </div>
        <!-- <router-link to="/volunteers/manage">Manage Volunteers</router-link> -->
      </div>
    </nav>
    <b-container fluid class="content">
      <router-view :key="$route.fullPath"></router-view>
    </b-container>
    <div style="height: 50px;">&nbsp;</div> 
    <nav class="navbar fixed-bottom footer">
      <a class="navbar-brand" href="#"></a>
    </nav>
  </b-container>
</template>

<script>
import { EventBus } from "@/components/event-bus.js";
import { userService } from "@/resources/UserService.js";
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      isLogged: false
    }
  },
  watch: {
    loggedIn: function(loggedIn) {
      if (loggedIn) {
        this.isLogged = true;
      }
      else {
        this.isLogged = false;
      }
    },
  },
  computed: mapGetters('account', ['loggedIn', 'isAdministrator']),
  
  mounted() {
    if(this.loggedIn) {
      this.isLogged = true; 
    }
  },
  created() {
    console.log("Created")
    // EventBus.$on("isLogged", result => {
    //   this.isLogged = result;
    // });

    // EventBus.$on("isAdmin", result => {
    //   console.log(result);
    //    this.isAdmin = result;
    //    console.log(this.isAdmin);
    // });

    // let roles = localStorage.roles;
    // if (roles == "Administrator") {
    //   this.isAdmin = true;
    // } else {
    //   this.isAdmin = false;
    // }
  },
  methods: {
    ...mapActions('account', ['logout']),
    // loggedIn(result) {
    //   this.logged = result;
    // },
    handleLogOut() {
      //EventBus.$emit("isLogged", false);
      //this.isLoggin = false;
      this.logout();
    }
    // async logout() {
    //   try {
    //     await this.axios.post("/auth/logout");
    //     localStorage.removeItem("user");
    //     location.reload(true);
    //   } catch (err) {
    //     console.error(err);
    //   }
    // }
  }
};
</script>


<style>
body {
  padding-top: 200px;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.navbar {
  background-color: #00a9e0;
}
#nav {
  background-color: #00a9e0;
  padding: 0px;
  display: inline-block;
}
#nav div {
  display: inline-block;
}
#nav a {
  font-weight: bold;
  color: #2c3e50;
  padding-right: 10px;
}

#nav a.router-link-exact-active {
  color: #fff;
}
.header {
  background-color: #00a9e0;
}
.content {
  padding-bottom: 100px;
  margin-top: -75px;
}
.fixed-botton {
  height: 6%;
}
.top-menu-nav{
  width: 775px;
}
@media screen and (max-width: 768px) {
  .top-menu-nav{
  width: 530px;
}
}

@keyframes click-wave {
  0% {
    height: 40px;
    width: 40px;
    opacity: 0.35;
    position: relative;
  }
  100% {
    height: 200px;
    width: 200px;
    margin-left: -80px;
    margin-top: -80px;
    opacity: 0;
  }
}

.option-input {
  -webkit-appearance: none;
  -moz-appearance: none;
  -ms-appearance: none;
  -o-appearance: none;
  appearance: none;
  position: relative;
  top: 13.33333px;
  right: 0;
  bottom: 0;
  left: 0;
  height: 40px;
  width: 40px;
  transition: all 0.15s ease-out 0s;
  background: #cbd1d8;
  border: none;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  margin-right: 0.5rem;
  outline: none;
  position: relative;
  z-index: 1000;
}
.option-input:hover {
  background: #9faab7;
}
.option-input:checked {
  background: #40e0d0;
}
.option-input:checked::before {
  height: 40px;
  width: 40px;
  position: absolute;
  content: "✔";
  display: inline-block;
  font-size: 26.66667px;
  text-align: center;
  line-height: 40px;
}
.option-input:checked::after {
  -webkit-animation: click-wave 0.35s;
  -moz-animation: click-wave 0.35s;
  animation: click-wave 0.35s;
  background: #40e0d0;
  content: "";
  display: block;
  position: relative;
  z-index: 100;
}
.option-input.radio {
  border-radius: 50%;
}
.option-input.radio::after {
  border-radius: 50%;
}
.row-align-left {
  text-align: left;
}
.invalid-radio-button {
  background-color: red;
}
</style>
